import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import Table from 'react-bootstrap/Table'


export const ViewSubscriberHistoryModal = ({ showModal, subscriberType, notificationdate, subhistoryData, onClose }) => {

    let [submitting, setSubmitting] = useState(false);
    let [submitted, setSubmitted] = useState(false);
    let [error, setError] = useState("")

    useEffect(() => {
        setSubmitting(false);
        setSubmitted(false);
    }, [showModal])

    return (
        <Modal show={showModal} onHide={onClose} dialogClassName={"modal-dialog-centered"}>
            <Modal.Header closeButton>
                <Modal.Title>Subscribers</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form >
                    <Form.Label>
                        {subscriberType} subscribers Notified on {notificationdate}
                    </Form.Label>
                    {!submitted && <Form.Group>
                        <Table responsive striped bordered hover size="sm" style={{ textAlign: 'center', display: 'block', height: '200px', overflow: 'auto' }}>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Subscriber</th>
                                </tr>
                            </thead>

                            <tbody>

                                {subhistoryData.map((val, key) => {
                                    return (
                                        <tr key={key}>
                                            <td>{val.name}</td>
                                            <td>{val.subscriber}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>

                        </Table>
                    </Form.Group>
                    }

                    <Row style={{ marginTop: '20px' }}>
                        <Col>
                            {!submitted && !submitting && <Button onClick={onClose}>
                                Cancel
                            </Button>}
                        </Col>
                        <Col style={{ textAlign: 'right' }}>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
        </Modal>)
}